// Base
import Head from 'next/head'

// Components
import MainLayout from '@components/v25/ft1/MainLayout'

// Packages
import { animateScroll as scroll } from 'react-scroll'

// Sections
import MembershipWrapper from '@sections/v25/ft1/membership/MembershipWrapper'
import InternationalTripWrapper from '@sections/v25/ft1/homepage/international-trip/InternationalTripWrapper'
import CustomerExperiences from '@sections/v25/ft1/customer-experiences/CustomerExperiences'
import TravelExperience from '@sections/v25/ft1/membership/travel-experience/TravelExperience'
import Airlines from '@sections/v25/ft1/airlines/Airlines'
import FAQ from '@components/v25/ft1/faq/FAQ'

// Images
import BeachBackground from '@images/v25/ft1/photos/beach-background-1.png'

// Data
import experiences from '@data/v25/ft1/experiences.json'

export default function Membership() {
  return (
    <>
      <Head>
        <title>RatePunk Premium | Membership</title>
        <meta name="description" content="RatePunk Premium" />
        <meta name="viewport" content="width=device-width, initial-scale=1" />
        <link rel="icon" href="/favicon.ico" />
      </Head>

      <MainLayout backgroundColor="#FCF8FC" displayCounter>
        <MembershipWrapper redirectURL="/v25/payment" />

        <CustomerExperiences
          title="Why Travelers Love RatePunk"
          description="See how we’ve helped customers save big and travel more."
          onClick={() => scroll.scrollToTop({ duration: 0 })}
          experiences={experiences.slice(2)}
        />

        <TravelExperience onClick={() => scroll.scrollToTop({ duration: 0 })} />

        <InternationalTripWrapper
          backgroundImage={BeachBackground}
          title="You’ll love the RatePunk service if..."
          features={[
            'You want to <b>save significant money</b> on your flights and travel more often.',
            'You <b>don&apos;t want to spend time</b> searching for great deals.',
            'You love discovering <b>new travel destinations</b> without breaking the bank.',
            'You want <b>personalized flight deals</b> sent directly to your inbox.'
          ]}
          onClick={() => scroll.scrollToTop({ duration: 0 })}
        />

        <Airlines onClick={() => scroll.scrollToTop({ duration: 0 })} />

        <FAQ theme="black" padding={[64, 0, 32]} />

        <MembershipWrapper />
      </MainLayout>
    </>
  )
}
